<template>
  <modal ref="modal" :openOnLoad="true" @close="$emit('close', $event)" @open="$emit('open', $event)">
    <template slot="title">
      Edit Note
    </template>
    <template slot="body">
      <div class="text-center" v-if="!contactNote">
        <loading />
      </div>
      <template v-else>
        <form-form @submit="handleSubmit" :submitError="submitError" :validator="$v">
          <form-textarea rows="5" label="Note" v-model="note" :validator="$v.note" />
          <form-datepicker
            placeholder="Date"
            v-model="date"
            :pick-time="true"
            :validator="$v.date"
            @input="dateChanged" />
          <form-checkbox label="Pin Note" v-model="pinned" />
          <div class="grid-x">
            <div class="cell auto">
              <form-submit :disabled="isLoading" :validator="$v" @click="handleSubmit">Submit</form-submit>
            </div>
            <div class="cell shrink">
              <button class="button alert clear" :disabled="isLoading" @click.prevent="deleteNote()">Delete Note</button>
            </div>
          </div>
        </form-form>
      </template>
    </template>
  </modal>
</template>

<script>
import Modal from '../../layouts/Modal.vue'
import { formsMixin } from '../../mixins/forms/formsMixin'
import { required } from 'vuelidate/lib/validators'
import Loading from '../../components/Common/Loading'
import moment from 'moment'
import { contactNoteQuery, updateContactNoteMutation } from '../../graphql/contacts'
import ContactsService from '../../services/ContactsService'

export default {
  components: {
    Loading,
    Modal
  },
  mixins: [
    formsMixin
  ],
  props: {
    id: Number
  },
  data () {
    return {
      note: null,
      date: moment().format('YYYY-MM-DD HH:mm'),
      pinned: false,
      submitError: null,
      isLoading: false
    }
  },
  validations: {
    note: { required },
    date: { required }
  },
  apollo: {
    contactNote: {
      query: contactNoteQuery,
      fetchPolicy: 'network-only',
      variables () {
        return {
          id: this.id
        }
      },
      update (data) {
        // update the local properties
        this.note = data.contactNote ? data.contactNote.note : ''
        this.date = data.contactNote ? data.contactNote.date : null
        this.pinned = data.contactNote ? !!data.contactNote.pinned_at : false
        return data.contactNote
      }
    }
  },
  methods: {
    closeModal () {
      this.$refs.modal.closeModal()
    },
    dateChanged () {
      // if the date is cleared, default to today's date
      if (!this.date) {
        this.date = moment().format('YYYY-MM-DD HH:mm')
      }
    },
    async handleSubmit () {
      this.isLoading = true

      try {
        // update the record
        await this.$apollo.mutate({
          mutation: updateContactNoteMutation,
          variables: {
            id: this.contactNote.id,
            note: this.note,
            date: this.date,
            pinned: this.pinned
          }
        })
        // notification
        this.$notifications.feedbackNotification(`Note saved`, 'success')
        // close the modal
        this.closeModal()
      } catch (e) {
        this.submitError = e
      }

      this.isLoading = false
    },
    async deleteNote () {
      if (this.isLoading) {
        return
      }
      if (confirm('Are you sure that you want to DELETE this note? This cannot be undone.')) {
        this.isLoading = true
        try {
          // delete using our service, which also handles re-fetching notes
          await ContactsService.deleteContactNote(this.contactNote.contact_id, this.contactNote.id)
          this.$notifications.feedbackNotification('Note deleted', 'success')
          this.closeModal()
        } catch (e) {
          this.submitError = e
        }
        this.isLoading = false
      }
    }
  }
}
</script>
